import { createTimeline, onScroll, animate } from 'animejs';

class MainSliderBanner {
	constructor(el) {
		this.container = el;
		this.init();
	}

	init() {
		const container = this.container;
		const sliderContainer = container.querySelector('.main-slider-banner__slider-container');
		const imagesContainer = container.querySelector('.main-slider-banner__slider');
		const bannerBackground = container.querySelector('.main-slider-banner__banner-background');
		const bannerInner1 = container.querySelector('.main-slider-banner__banner-inner-1');
		const bannerInner2 = container.querySelector('.main-slider-banner__banner-inner-2');
		const bannerInner3 = container.querySelector('.main-slider-banner__banner-inner-3');

		if (container.classList.contains('collections-slider-banner')) {
			container.style.opacity = 1;
			this.startMarquee(imagesContainer);
			return;
		}

		if (!container) return;
		container.style.opacity = 1;

		const tm = createTimeline({
			autoplay: onScroll({
				target: container,
				axis: 'y',
				sync: true,
				enter: 'top top',
				leave: 'bottom bottom',
			}),
			defaults: {
				ease: 'linear',
			},
		});

		const MOBILE = '(max-width: 769px)';
		const mm = window.matchMedia(MOBILE);

		const handleResize = () => {
			if (mm.matches) {
				this.destroy();
				tm.add(sliderContainer, { scale: [2, 1] }, 0);
				tm.add(bannerBackground, { height: ['400%', '100%'] }, 0);
				tm.add(bannerInner1, { scaleY: [4, 1] }, 0);
				tm.add(bannerInner2, { scaleY: [4, 1] }, 0);
				tm.add(bannerInner3, { scaleY: [4, 1] }, 0);
				tm.init();
			} else {
				this.destroy();
				tm.add(sliderContainer, { scale: [1.5, 1] }, 0);
				tm.add(bannerBackground, { height: ['150%', '100%'] }, 0);
				tm.add(bannerInner1, { scaleY: [1.5, 1] }, 0);
				tm.add(bannerInner2, { scaleY: [1.5, 1] }, 0);
				tm.add(bannerInner3, { scaleY: [1.5, 1] }, 0);
				tm.init();
			}
		};

		handleResize();
		mm.addEventListener('change', handleResize);

		if (!this.marquee) {
			tm.then(() => {
				this.startMarquee(imagesContainer);
			});
		}
	}

	destroy() {
		if (this.timeline) {
			try {
				this.timeline.revert();
			} catch (e) {}
			this.timeline = null;
		}
	}

	startMarquee(imagesContainer) {
		if (!imagesContainer) return;

		if (!imagesContainer.querySelector('img.__clone')) {
			const imgs = Array.from(imagesContainer.querySelectorAll('img'));
			imgs.forEach((img) => {
				const clone = img.cloneNode(true);
				clone.classList.add('__clone');
				imagesContainer.appendChild(clone);
			});
		}

		let origWidth = imagesContainer.scrollWidth / 2;
		let pos = 0;
		let lastTimestamp = null;

		const step = (timestamp) => {
			if (!lastTimestamp) lastTimestamp = timestamp;
			const delta = timestamp - lastTimestamp;
			lastTimestamp = timestamp;

			const speed = origWidth / 35000;
			pos += speed * delta;
			if (pos >= origWidth) pos -= origWidth;

			imagesContainer.style.transform = `translateX(${-pos}px)`;
			requestAnimationFrame(step);
		};

		requestAnimationFrame(step);

		window.addEventListener('resize', () => {
			origWidth = imagesContainer.scrollWidth / 2;
			pos = pos % origWidth;
		});
	}
}

document.querySelectorAll('[data-main-slider-banner]').forEach((el) => new MainSliderBanner(el));
export default MainSliderBanner;
